export default {
  noJobs: 'No jobs posted for the next 7 days'
};
